<template>
  <div>
    <button @click="showModal('product')" class="btn btn-sm btn-warning mb-4">
      <span class="ti-plus"></span>
    </button>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :params="params"
      :functions="functions"
      :fields="fields"
      :searchDisable="false"
      @changeFunction="changeFunction"
      v-model="val"
    />
    <list-item
      v-if="modal"
      :modal="modal"
      v-model="selectData[modal]"
      :simple="false"
      @input="pushItem"
    />
  </div>
</template>

<script>
import { cardUpdate, moveIndex } from "../../../plugins/functions";

export default {
  created() {
    this.params["id"] = this.id;
  },
  components: {
    "list-item": () => import("../../Modals/ListItem"),
    list: () => import("../../List"),
    "sub-field-list": () => import("../SubFieldList"),
  },
  data: () => ({
    val: [],
    modalCreate: "",
    params: {},

    functions: [
      {
        id: 1,
        title: "Удалить из списка",
      },
    ],

    fields: [],
    removeLink: "labels/reject",
    cardLink: "product",
    itemLink: "labels/items",
    setLink: "labels/add",
    columns: [
      {
        key: "image",
        title: "Изображение",
        image: true,
      },
      {
        key: "display_name",
        title: "Название",
        checkbox: true,
        full: true,
        control: false,
        align: "left",
        timer: false,
        detail: false,
      },
    ],
    cardSetLink: "labels/update",
    cardPushLink: "labels/push",
    cardRejectLink: "labels/reject",
    showCreate: false,
    modal: "",
    selectData: {},
  }),
  props: ["id"],
  methods: {
    cardUpdate: cardUpdate,
    moveIndex: moveIndex,
    changeFunction(val) {
      switch (val) {
        case 1:
          this.cardUpdate(
            `${this.cardRejectLink}?id=${this.id}`,
            { items: this.val },
            "delete"
          );
          break;
        default:
          break;
      }
      this.val = [];
    },
    showModal(modal) {
      this.selectData[modal] = [];
      this.modal = modal;
      setTimeout(() => {
        this.$modal.show(this.modal);
      }, 10);
    },
    pushItem(val) {
      this.cardUpdate(
        `${this.cardPushLink}?id=${this.id}`,
        { items: val },
        "post"
      );
    },
  },
};
</script>
